import { zonedTimeToUtc } from 'date-fns-tz';
import type { CustomEOD } from '../../../../providers/customEOD';

function padTime(value: number) {
  return value < 10 ? `0${value.toString()}` : value.toString();
}

export function customEODToRequestEOD(
  eod: CustomEOD,
  supportedTimezones: readonly string[],
  referenceDate: Date = new Date()
): string {
  const timezone = eod.timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone;

  if (supportedTimezones.includes(timezone)) {
    return `${padTime(eod.hours)}:${padTime(eod.minutes)} ${timezone}`;
  }

  const wallClockInZone = new Date(
    referenceDate.getFullYear(),
    referenceDate.getMonth(),
    referenceDate.getDate(),
    eod.hours,
    eod.minutes,
    0,
    0
  );
  const utcDate = zonedTimeToUtc(wallClockInZone, timezone);
  return `${padTime(utcDate.getUTCHours())}:${padTime(utcDate.getUTCMinutes())}`;
}

export function dateToRequestEOD(date: Date | string): string {
  const customEODDate = new Date(date);
  const utcHours = customEODDate.getUTCHours();
  const utcMinutes = customEODDate.getUTCMinutes();
  return `${padTime(utcHours)}:${padTime(utcMinutes)}`;
}
